import axios from "axios";

const instance = axios.create({
  withCredentials: false,
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": process.env.REACT_APP_API_KEY,
  },
});

export default instance;

// import axios from "axios";

// const instance = axios.create({
//   baseURL: process.env.REACT_APP_BASE_URL,

//   headers: {
//     post: {
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//     get: {
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//   },
//   withCredentials: false, //can be true when auth is required
// });

// export default instance;
